"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }






// View models for the search window (web plan package P7, mobile M6).
// Platform-neutral: webChat's search window and mobileChat's search screen
// both build on these.




 const GROUPS = [
  { key: 'chats', label: 'Chats', searchType: 'conversation' },
  { key: 'messages', label: 'Messages', searchType: 'text' },
  { key: 'files', label: 'Files', searchType: 'file' },
]; exports.GROUPS = GROUPS

// Who is in a result's chat, to draw its avatar as the inbox does.




























const subscribersOf = (from) =>
  from.UserSubscribers || from.TeamSubscribers || from.PatientSubscribers
    ? {
        UserSubscribers: _nullishCoalesce(from.UserSubscribers, () => ( {})),
        TeamSubscribers: _nullishCoalesce(from.TeamSubscribers, () => ( {})),
        PatientSubscribers: _nullishCoalesce(from.PatientSubscribers, () => ( {})),
      }
    : undefined










 const EMPTY_GROUP = { items: [], totalHits: 0, page: 0, hasMore: false }; exports.EMPTY_GROUP = EMPTY_GROUP

 const EMPTY_RESULTS = {
  chats: exports.EMPTY_GROUP,
  messages: exports.EMPTY_GROUP,
  files: exports.EMPTY_GROUP,
}; exports.EMPTY_RESULTS = EMPTY_RESULTS




// Newest first, as today (decision D9).
 const toMessageItems = (results, group) =>
  Object.values(results)
    .sort((a, b) => b.TimeStamp.localeCompare(a.TimeStamp))
    .map(item => ({
      id: `${group}:${item.ConversationKey}-${item.MessageKey}`,
      group,
      chatName: item.Title,
      senderName: item.SenderName || undefined,
      text: item.Subtitle,
      timestamp: item.TimeStamp,
      bKey: item.BlobKey,
      cKey: item.ConversationKey,
      type: item.WrappedType || 'chat',
      mKey: item.MessageKey,
      sequence: item.Sequence,
      subscribers: subscribersOf(item),
      senderKey: item.SenderKey || undefined,
      senderType: item.SenderType || undefined,
      senderAvatar: item.SenderAvatar || undefined,
      thumbnailUrl: item.ThumbnailURL || undefined,
    })); exports.toMessageItems = toMessageItems

 const toChatItems = (results) =>
  Object.values(results)
    .sort((a, b) => b.InboxSortTime.localeCompare(a.InboxSortTime))
    .map(chat => ({
      id: `chats:${chat.Key}-${chat.WrappedKey}`,
      group: 'chats',
      chatName: chat.Name,
      text: chat.Description,
      timestamp: chat.UpdatedAt,
      bKey: chat.Key,
      cKey: chat.WrappedKey,
      type: chat.WrappedType,
      subscribers: subscribersOf(chat),
    })); exports.toChatItems = toChatItems

// The All tab shows three of each group, as today.
 const ALL_TAB_PER_GROUP = 3; exports.ALL_TAB_PER_GROUP = ALL_TAB_PER_GROUP

 const visibleItems = (results, tab) =>
  exports.GROUPS.flatMap(({ key }) => {
    if (tab === 'all') return results[key].items.slice(0, exports.ALL_TAB_PER_GROUP)
    return tab === key ? results[key].items : []
  }); exports.visibleItems = visibleItems

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/**
 * Splits `text` around the words of `query`, case-insensitively. Odd indexes
 * are matches. A long text is cut to start a little before the first match,
 * so the hit is visible on one line.
 */
 const splitOnQuery = (text, query, lead = 24) => {
  const words = query.trim().split(/\s+/).filter(Boolean).map(escapeRegExp)
  if (!words.length) return [text]
  const matcher = new RegExp(`(${words.join('|')})`, 'gi')
  const first = text.search(matcher)
  if (first <= lead) return text.split(matcher)
  // Start on a word boundary inside the lead, when there is one.
  const cut = first - lead
  const space = text.slice(cut, first).search(/\s/)
  const start = space === -1 ? cut : cut + space + 1
  return `…${text.slice(start)}`.split(matcher)
}; exports.splitOnQuery = splitOnQuery
